const base64 = require("base-64");

export const Base64func = (value, type) => {
  if (type == "decode") {
    return base64.decode(value.toString());
  } else if (type == "encode") {
    return base64.encode(value.toString());
  }
};
